import { IDate } from "../../components/Table/hooks/useDateFilter";
import { IDatatableV2AdvancedSearchFilter } from "../../components/TableV2/preDefinedPlugins/SearchFilter/SearchFilter.types";
import { LoadState } from "../../constants/enums";

export interface ICommonState {
	policies: {
		list: IPolicies[];
		loadState: LoadState;
	};
	generalHistory: {
		list: IGeneralHistory[];
		loading: LoadState;
	};
	recordCounts: {
		list: IRecordCount[];
		loading: LoadState;
	};
	recordCountsV2: {
		list: IRecordCount[];
		loading: LoadState;
	};
	modules: {
		tableNames: {
			data: string[];
			loading: LoadState;
		};
		tableViews: {
			data: string[];
			loading: LoadState;
		};
	};
	reportee_referrals: {
		list: IReporteeReferrals[];
		loadState: LoadState;
	};
	packages: {
		list: IPackage[];
		loadState: LoadState;
	};
	brands?: {
		list: any[];
		loadState?: LoadState;
	};
	models?: {
		list: any;
		loadState?: LoadState;
	};
	faultType?: {
		list: Record<string, any[]>;
		loadState: LoadState;
	};
	faultName?: {
		list: Record<string, any[]>;
		loadState: LoadState;
	};
	subFaultName?: {
		list: Record<string, any[]>;
		loadState: LoadState;
	};
}

export interface ISearchQueryParams {
	status?: string;
	membership?: string;
	page?: number;
	rowsPerPage?: number;
	limit?: number;
	columns?: string[];
	value?: string;
	date?: IDate;
	contact_number?: string;
	vehicle_number?: string;
	membership_code?: string;
	email_id?: string;

	companyOutletUuid?: string;
	advancedFilters?: IDatatableV2AdvancedSearchFilter;
	partnerId?: number;
	customFilters?: Record<string, any>; // Custom filters from filter accordion
	promocode?: string;
	package_uuid?: string;

}


export interface IReporteeReferrals {
	branch_office: string;
	reportee_id: number;
	reportee: string;
	reportee_role: string;
	reportee_email_id: string;
	reportee_referral_code: string;
	manager_id: number;
	reporting_manager: string;
	manager_role: string;
	email_id: string;
}

export interface IRecordCount {
	status: string;
	count: number;
}

export interface IPolicies {
	type: string;
	subTypes: {
		policy_id: number;
		name: string;
	}[];
}

export interface IGeneralHistory {
	insert_ts: string;
	[key: string]: any;
}

export const defaultCommonState: ICommonState = {
	policies: {
		list: [],
		loadState: LoadState.NotLoaded,
	},
	generalHistory: {
		list: [],
		loading: LoadState.NotLoaded,
	},
	recordCounts: {
		list: [],
		loading: LoadState.NotLoaded,
	},
	recordCountsV2: {
		list: [],
		loading: LoadState.NotLoaded,
	},
	modules: {
		tableNames: {
			data: [],
			loading: LoadState.NotLoaded,
		},
		tableViews: {
			data: [],
			loading: LoadState.NotLoaded,
		},
	},
	reportee_referrals: {
		list: [],
		loadState: LoadState.NotLoaded,
	},
	packages: {
		list: [],
		loadState: LoadState.NotLoaded,
	},
	faultType: {
		list: {},
		loadState: LoadState.NotLoaded,
	},
	faultName: {
		list: {},
		loadState: LoadState.NotLoaded,
	},
	subFaultName: {
		list: {},
		loadState: LoadState.NotLoaded,
	},
};

export interface IMail {
	from_email: string | null;
	from_name: string | null;
	emails: string[];
	subject: string;
	body: string;
	templateName: string | null;
	templateId: string | null;
	objectVariables: any;
	cc: string[];
	bcc: string[];
	reply_to?: {
		email: string;
		name: string;
	};
	attachments?: {
		content: string;
		filename: string;
	}[];
	history?: {
		module_name: string;
		module_code: string;
	};
}

export interface IQueryParams {
	page: number;
	rowsPerPage: number;
	status: string;
	columns: string[];
	value: string;
	fromDate?: string;
	toDate?: string;
}

export interface IMail {
	// from_email: string | null;
	// from_name: string | null;
	emails: string[];
	subject: string;
	body: string;
	templateName: string | null;
	objectVariables: any;
	cc: string[];
	bcc: string[];
	reply_to?: {
		email: string;
		name: string;
	};
	attachments?: {
		content: string;
		filename: string;
	}[];
	history?: {
		module_name: string;
		module_code: string;
	};
}

export interface IEventTime {
	event_timing_id: number;
	event_timing_uuid: string;
	event_name: string;
	description: string;
	status: string;
	created_by_uuid: string | null;
	created_by_name: string | null;
	modified_by_uuid: string | null;
	modified_by_name: string | null;
	create_ts: string; // ISO date string
	insert_ts: string; // ISO date string
}
export interface ISession {
	session_info_id: number;
	session_info_unique_id: number;
	session_info_uuid: string;
	session_name: string;
	session_duration_in_years: string;
	session_starting_date: string; // ISO date string
	session_ending_date: string; // ISO date string
	status: string; // e.g., "ACTIVE"
	created_by_uuid: string;
	created_by_name: string;
	modified_by_uuid: string;
	modified_by_name: string;
	create_ts: string; // ISO date string
	insert_ts: string; // ISO date string
}

export interface IOrganization {
	organizations_id: number;
	organizations_unique_id: number;
	organizations_uuid: string;
	organizations_name: string;
	status: string;
	created_by_uuid?: string;
	created_by_name?: string;
	modified_by_uuid?: string;
	modified_by_name?: string;
	create_ts?: string | null;
	insert_ts?: string;
}

export interface IPackage {
	package_id: number;
	old_package_id: number;
	package_name: string;
	package_price_excluding_gst: number;
	package_price: number;
	gst_percentage: number;
	gst_amount: number;
	vehicle_type: string;
	city: string;
	duration: number;
	partner_name: string;
	no_of_services: number;
	insert_dt: string;
	status: string;
	comment: string;
}